import React from 'react'
import { Helmet } from 'react-helmet-async'
import { MediaLibraryLayout } from '../../layouts/MediaLibrary'

const MediaLibraryPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet titleTemplate="%s - ImageKit Media Library">
      <title>Media Library</title>
      <meta name="description" content="Media Library page" />
    </Helmet>
    <MediaLibraryLayout />
  </React.Fragment>
)

export default MediaLibraryPage
